<template>
  <div class="h-full">
    <RouterView v-if="isReady" />
    <div v-else class="relative h-full w-full">
      <BaseContainerLoading />
    </div>
    <DialogsWrapper />
  </div>
</template>

<script setup lang="ts">
import "@/styles/inter.css";
import { DialogsWrapper } from "vuejs-confirm-dialog";

const { logOut, isLoggedIn } = useAuth();
const isReady = ref(false);
const { hydrateCurrentUser, clearCurrentUser } = useCurrentUser();

onMounted(async () => {
  // The refresh token is an httpOnly cookie we can't see, so just try it: a
  // 401 means there is no session, and BaseLayout sends the user to log in.
  try {
    await refreshAccessToken();
  } catch {
    logOut();
  }

  isReady.value = true;
});

watch(
  isLoggedIn,
  async (newIsLoggedIn) => {
    if (newIsLoggedIn) {
      hydrateCurrentUser();
    } else {
      clearCurrentUser();
    }
  },
  {
    immediate: true,
  },
);
</script>

<style>
:root {
  --color-primary: 210 94 21;
  --color-on-primary: 255 255 255;
  --color-secondary: 0 149 144;
  --color-on-secondary: 255 255 255;
  --color-background: 255 255 255;
  --color-on-background: 0 0 0;
}
</style>
